/*
  cstrap-atc.js — THEM GIO 1 CHAM, KHONG TRUNG (08/10/2026, chu shop). Dung chung form V1 (custom-strap-form) + V2.
  Nap TRUOC engine. Engine goi:
    CSTRAP_ATC.dangGui()          — dau handler submit: dang gui thi bo qua (chan dup), ghi atc_duplicate_blocked
    CSTRAP_ATC.batDau(form, fd)   — ngay truoc fetch /cart/add: khoa NGAY nut chinh + nut thanh dinh ("Adding…", aria-busy);
                                    cung bo property gui lai trong 5 s -> false (khong gui)
    CSTRAP_ATC.xong(form, ok, chu)— xong: thanh cong -> "Added ✓" ~1.5 s roi mo khoa; loi -> mo khoa ngay + bao loi duoi nut,
                                    KHONG tu gui lai
    CSTRAP_ATC.tap()              — dem cham thanh dinh (cbar_tap)
  Su kien do luong (Shopify.analytics.publish, chi product_handle — khong du lieu ca nhan):
    cbar_tap · atc_request · atc_success (kem ms) · atc_duplicate_blocked
  ?debug=1 — goc tren trai: "tap: n · add: n · chan trung: n" (de chu shop dem tren may that).
*/
(function () {
  if (window.CSTRAP_ATC) return;
  var HANDLE = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
  var dang = false, cuoi = { ky: '', t: 0 }, t0 = 0;
  var dem = { tap: 0, add: 0, trung: 0 };
  var DEBUG = /[?&]debug=1\b/.test(location.search);

  function pub(ten, them) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        var d = { product_handle: HANDLE }; for (var k in (them || {})) d[k] = them[k];
        Shopify.analytics.publish(ten, d);
      }
    } catch (e) {}
    veDem();
  }
  function veDem() {
    if (!DEBUG) return;
    var el = document.getElementById('cstrap-atc-dem');
    if (!el) {
      el = document.createElement('div'); el.id = 'cstrap-atc-dem';
      el.style.cssText = 'position:fixed;top:4px;left:4px;z-index:2147483647;background:#111;color:#fff;font:12px/1.4 system-ui;padding:4px 8px;border-radius:6px;pointer-events:none;opacity:.9';
      document.body.appendChild(el);
    }
    el.textContent = 'tap: ' + dem.tap + ' · add: ' + dem.add + ' · chặn trùng: ' + dem.trung;
  }
  function cacNut(form) {
    var ds = [];
    var a = form && form.querySelector('[type="submit"]'); if (a) ds.push(a);
    document.querySelectorAll('.cbar__nut').forEach(function (b) { ds.push(b); });
    return ds;
  }
  function chuNut(b, chu, quay) {
    if (b.dataset.atcGoc == null) b.dataset.atcGoc = b.innerHTML;
    b.innerHTML = (quay ? '<span class="catc-quay" aria-hidden="true"></span>' : '') + chu;
  }
  function traNut(b) { if (b.dataset.atcGoc != null) { b.innerHTML = b.dataset.atcGoc; delete b.dataset.atcGoc; } }
  function khoa(form) {
    cacNut(form).forEach(function (b) { b.classList.add('is-dang-them'); b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); chuNut(b, 'Adding…', true); });
  }
  function moKhoa(form) {
    cacNut(form).forEach(function (b) { b.classList.remove('is-dang-them', 'is-da-them'); b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); traNut(b); });
  }
  function kyHieu(fd) {
    var ds = [];
    fd.forEach(function (v, k) { if (k === 'sections' || k === 'sections_url') return; ds.push(k + '=' + (typeof v === 'string' ? v : (v && v.name) + ':' + (v && v.size))); });
    return ds.join('&');
  }
  function baoLoi(form, chu) {
    var a = form && form.querySelector('[type="submit"]'); if (!a) return;
    var p = form.querySelector('.catc-loi');
    if (!p) { p = document.createElement('p'); p.className = 'catc-loi'; p.setAttribute('role', 'alert'); a.insertAdjacentElement('afterend', p); }
    p.textContent = chu || 'Couldn’t add to cart — please check your connection and try again.';
    p.hidden = false;
  }

  window.CSTRAP_ATC = {
    dem: dem,
    dangGui: function () {
      if (!dang) return false;
      dem.trung++; pub('atc_duplicate_blocked', { ly_do: 'dang_gui' });
      return true;
    },
    batDau: function (form, fd) {
      var ky = kyHieu(fd), now = Date.now();
      if (dang) { dem.trung++; pub('atc_duplicate_blocked', { ly_do: 'dang_gui' }); return false; }
      if (ky === cuoi.ky && now - cuoi.t < 5000) { dem.trung++; pub('atc_duplicate_blocked', { ly_do: 'cung_bo_5s' }); return false; }
      dang = true; cuoi = { ky: ky, t: now }; t0 = now;
      var p = form && form.querySelector('.catc-loi'); if (p) p.hidden = true;
      khoa(form);
      pub('atc_request');
      return true;
    },
    xong: function (form, ok, chu) {
      dang = false;
      if (ok) {
        dem.add++; pub('atc_success', { ms: Date.now() - t0 });
        cacNut(form).forEach(function (b) { b.classList.remove('is-dang-them'); b.classList.add('is-da-them'); chuNut(b, 'Added ✓', false); });
        setTimeout(function () { moKhoa(form); }, 1500);
      } else {
        cuoi = { ky: '', t: 0 };   /* loi -> cho phep khach tu bam lai (khong tu gui lai) */
        moKhoa(form); baoLoi(form, chu);
      }
    },
    tap: function () { dem.tap++; pub('cbar_tap'); }
  };
  if (DEBUG) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', veDem); else veDem(); }
})();
